import Add from '@mui/icons-material/Add';
import Stack, { StackProps as MuiStackProps } from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import { useCallback } from 'react';
import { Chip, IChipProps } from '../Chip';

export type IChipStackValue = Pick<IChipProps, 'color'> & {
    id: string;
    label: string;
    title?: string;
    avatar?: IChipProps['avatar'];
};
export type IChipStackProps = Omit<MuiStackProps, 'onChange'> &
    Pick<IChipProps, 'variant'> & {
        disabled?: boolean;
        name: string;
        noAdd?: boolean;
        noDelete?: boolean;
        options: IChipStackValue[];
        readOnly?: boolean;
        value?: IChipStackValue['id'][];
        onChange?: (newValue: IChipStackValue['id'][]) => void;
    };

const StyledStack = styled(Stack)(
    ({ theme }) => `
        gap: ${theme.spacing(1)};
    `
);

export const ChipStack = ({
    disabled,
    noAdd,
    noDelete,
    options,
    readOnly,
    value = [],
    variant,
    onChange,
    ...props
}: IChipStackProps) => {
    const handleDelete = useCallback(
        (id: string) => {
            if (!readOnly && !noDelete && onChange) {
                onChange(value.filter((item) => item !== id));
            }
        },
        [noDelete, readOnly, value, onChange]
    );

    return (
        <StyledStack {...props}>
            {options.map(({ id, ...rest }) => (
                <Chip
                    {...rest}
                    key={id}
                    name={id.toString()}
                    variant={variant}
                    disabled={disabled}
                    onDelete={handleDelete}
                />
            ))}

            {!disabled && !readOnly && !noAdd ? (
                <Chip
                    name="add"
                    variant={variant}
                    color="primary"
                    avatar={<Add color="inherit" />}
                    disabled={disabled}
                />
            ) : null}
        </StyledStack>
    );
};
